import * as React from "react";
import { Option } from "../../db";
import { Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalBody } from "@chakra-ui/core";
import { styled } from "theme";

export interface Props {
  option: Option | null;
  onClose: () => void;
}

const InfoPopup: React.FC<Props> = ({ option, onClose }) => {
  const [isOpen, setIsOpen] = React.useState(false);

  React.useEffect(() => {
    setIsOpen(option !== null);
  }, [option]);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="xl" isCentered>
        <ModalOverlay />
        <ModalContent backgroundColor={"#322f2a"}>
          <ModalCloseButton color="#fff" />
          <ModalBody p={0}>
            <InfoContent>
              <h2>{option?.name}</h2>
              <p>{option?.description}</p>
              {option?.image && <Image src={`/_clientfiles/${option!.image}`} />}
            </InfoContent>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default InfoPopup;

const InfoContent = styled.div`
  h2 {
    color: ${(props) => props.theme.colors.green["400"]};
    font-size: 22px;
    padding: 32px;
  }

  p {
    font-size: 16px;
    padding: 0 32px 16px 32px;
    margin: 0;
    color: ${(props) => props.theme.colors.gray["100"]};
  }

  @media (max-width: 400px) {
    h2 {
      padding: 16px 60px 8px 16px;
    }

    p {
      padding: 0 16px 8px 16px;
    }
  }
`;

const Image = styled.div<{ src: string }>`
  background: #333 url("${(props) => props.src}") no-repeat center center;
  background-size: cover;
  width: 100%;
  height: 300px;
  max-width: 100%;
`;
